const DetailsListSection = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="lg:flex-shrink-0">
      <div className="px-2">
        <ul className="divide-y divide-gray-200">{children}</ul>
      </div>
    </div>
  );
};

export default DetailsListSection;
